import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.stability');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-overview-widget-stability',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.stability/view.scss */
/* src/app/portal.overview.widget.stability/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetStabilityComponent implements OnInit, OnChanges {
    @Input() data: ResearcherData;
    @Input() years: number[];
    @Input() period: any;

    public researcher: any[];
    public products: any[];
    public keyword = "";

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.loadData();
        }
    }

    constructor(@Inject( Service) private service: Service) { }

    public avgCount = 0;
    public datasets = [];

    public chartLine: Chart | null = null;

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.loadData();
        await this.service.render();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.data.period.end;
        this.periodStart = this.data.period.start;
        this.products = this.data.products;
        this.service.render();
    }

    private loadData() {
        if (!this.products || !this.years) return;

        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        const keywordYearMap: Record<string, number[]> = {};

        for (const p of filtered) {
            const year = Number(p.pub_year);
            if (!year || !this.years.includes(year)) continue;

            let raw = p.kr_keywords?.trim() || p.en_keywords?.trim();
            if (!raw) continue;

            const parts = raw.split(";").map(x => x.trim()).filter(x => x.length > 0);

            for (const kw of parts) {
                if (!keywordYearMap[kw]) {
                    keywordYearMap[kw] = this.years.map(() => 0);
                }
                const idx = this.years.indexOf(year);
                if (idx >= 0) {
                    keywordYearMap[kw][idx] += 1;
                }
            }
        }

        this.datasets = Object.entries(keywordYearMap).map(([kw, data], i) => {
            const total = data.reduce((a, b) => a + b, 0);
            return {
                label: kw,
                data: data,
                total: total,
                borderColor: this.randomColor(i),
                backgroundColor: this.randomColor(i),
            };
        });

        this.datasets = (this.datasets ?? []).sort((a: any, b: any) => b.total - a.total);
        if (this.datasets.length > 0) {
            const totalAll = this.datasets.reduce((sum, ds) => sum + ds.total, 0);
            this.avgCount = Math.round(totalAll / this.years.length);
        } else {
            this.avgCount = 0;
        }

        setTimeout(() => this.renderLineChart(), 0);
    }

    public highlight(k) {
        this.keyword = (this.keyword === k) ? '' : k;
        this.updateHighlight();
        this.service.render();
    }

    private renderLineChart(): void {
        if (this.chartLine) this.chartLine.destroy();
        this.chartLine = new Chart('lineChart', {
            type: 'line',
            data: {
                labels: this.years,
                datasets: this.datasets.map(ds => ({
                    ...ds,
                    fill: false,
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 5,
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 2
                }))
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        offset: false,
                        grid: { display: false },
                        ticks: { color: '#000', font: { size: 16, weight: 'bold' }, autoSkip: false }
                    },
                    y: {
                        beginAtZero: true,
                        grid: { color: '#E2E6F2' },
                        ticks: {
                            display: false,
                            stepSize: 1,
                            precision: 0
                        },
                        border: { display: false }
                    }
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}건`
                        }
                    }
                }
            }
        } as ChartConfiguration);
    }

    private alphaColor(color: any, alpha: number): any {
        if (typeof color !== 'string') return color;

        if (color.startsWith('#')) {
            let hex = color.slice(1);
            if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }

        const m = color.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
        if (m) return `rgba(${m[1]}, ${m[2]}, ${m[3]}, ${alpha})`;

        return color;
    }

    // private updateHighlight(): void {
    //     if (!this.chartLine) return;

    //     const selected = (this.keyword ?? '').trim();

    //     this.chartLine.data.datasets.forEach((ds: any) => {
    //         const isOn = !selected || ds.label === selected;

    //         const baseColor = ds._baseBorderColor ?? ds.borderColor ?? '#000';
    //         if (!ds._baseBorderColor) ds._baseBorderColor = baseColor;

    //         ds.borderColor = this.alphaColor(baseColor, isOn ? 1 : 0.15);
    //         ds.pointBorderColor = this.alphaColor(baseColor, isOn ? 1 : 0.15);

    //         ds.borderWidth = isOn ? 3 : 1.5;
    //         ds.pointRadius = isOn ? 6 : 2;

    //         ds.pointBackgroundColor = '#fff';
    //     });

    //     this.chartLine.update();
    // }

    private updateHighlight(): void {
        if (!this.chartLine) return;

        const selected = (this.keyword ?? '').trim();

        this.chartLine.data.datasets.forEach((ds: any) => {
            const isOn = !selected || ds.label === selected;

            const baseColor = ds._baseBorderColor ?? ds.borderColor ?? '#000';
            if (!ds._baseBorderColor) ds._baseBorderColor = baseColor;

            if (isOn) {
                ds.borderColor = this.alphaColor(baseColor, 1);
                ds.pointBorderColor = this.alphaColor(baseColor, 1);
                ds.pointBackgroundColor = '#fff';

                ds.borderWidth = 3;
                ds.pointRadius = 6;
                ds.pointHoverRadius = 7;
                ds.pointBorderWidth = 2;
            } else {
                // ✅ 완전 숨김
                ds.borderColor = this.alphaColor(baseColor, 0);
                ds.pointBorderColor = this.alphaColor(baseColor, 0);
                ds.pointBackgroundColor = this.alphaColor('#fff', 0); // 또는 'rgba(255,255,255,0)'

                ds.borderWidth = 0;
                ds.pointRadius = 0;
                ds.pointHoverRadius = 0;
                ds.pointBorderWidth = 0;
            }
        });

        this.chartLine.update();
    }


    private randomColor(): string {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
}

export default PortalOverviewWidgetStabilityComponent;